module.exports = __webpack_public_path__ + "static/img/touXiang.8f5c789d.png";